import React, { useEffect, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import { IoClose } from "react-icons/io5";
import Select from "react-select";
import { MdError } from "react-icons/md";
import { getLocation } from "../../Api/services/org-StructureService";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";

function Filter({
  closeDrawer,
  handleChange,
  selectedLocation,
  submitFilter,
  t,
}) {
  const dispatch = useDispatch();
  const fillterRef = useRef();
  //intial state
  const { locationOptions, loading } = useSelector(
    (state) => state?.orgStructure
  );
  //eror state
  const [error, setError] = useState("");

  //get location data for dropdown
  useEffect(() => {
    dispatch(getLocation());
  }, [dispatch]);

  // Create options using location data
  const locationDropdownOptions =
    locationOptions?.data?.locations.map((location) => ({
      value: location?.id,
      label: location?.name,
    })) || [];

  //select any location
  const handleSelectChange = (selectedOption) => {
    setError(""); // Clear error when an option is selected
    handleChange(selectedOption);
  };
  //filter submit button function
  const handleFilterSubmit = () => {
    if (!selectedLocation) {
      setError(t("organizations.filters.error_message"));
    } else {
      setError("");
      submitFilter();
    }
  };
  //clik out functiona
  const handleClickOutside = (event) => {
    if (fillterRef.current && !fillterRef.current.contains(event.target)) {
      closeDrawer();
    }
  };

  //when user clicks outside of component close the sidebar
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="p-5 my-9" ref={fillterRef}>
      <div className="flex justify-between py-[22px]">
        <h6>{t("organizations.filters.filters_title")}</h6>
        <button onClick={closeDrawer}>
          <IoClose className="text-2xl text-gray_900" />
        </button>
      </div>

      <div className="border-t border-gray_border py-5">
        <div className="">
          <Select
            value={selectedLocation}
            onChange={handleSelectChange}
            options={locationDropdownOptions}
            placeholder={t("organizations.filters.locations_placeholder")}
            className="w-full min-w-72"
            isClearable
          />
        </div>
        {error && <p className="text-red-500 text-xs pt-2">{error}</p>}
      </div>

      <button
        onClick={handleFilterSubmit}
        type="submit"
        className="mt-5 text-sm font-semibold font-pop text-white border border-transparent hover:border-primary_orange hover:text-primary_orange hover:bg-transparent py-3 px-[26px] rounded-[14px] transition-all ease-in-out duration-300 bg-primary_orange w-full"
      >
        {loading ? (
          <Loader />
        ) : (
          <span>{t("organizations.filters.filter_button")}</span>
        )}
      </button>
    </div>
  );
}

export default withNamespaces()(Filter);
